// Most functions in this file are based on
// https://github.com/mixpanel/mixpanel-js/blob/master/src/utils.js

/* istanbul ignore next */
export const getBrowser = () => {
  const ua = navigator.userAgent;
  const vendor = navigator.vendor || ''; // vendor is undefined for at least IE9

  if (ua.includes(' OPR/')) {
    if (ua.includes('Mini')) {
      return 'Opera Mini';
    }
    return 'Opera';
  } else if (/(BlackBerry|PlayBook|BB10)/i.test(ua)) {
    return 'BlackBerry';
  } else if (ua.includes('IEMobile') || ua.includes('WPDesktop')) {
    return 'Internet Explorer Mobile';
  } else if (ua.includes('SamsungBrowser/')) {
    // https://developer.samsung.com/internet/user-agent-string-format
    return 'Samsung Internet';
  } else if (ua.includes('Edge') || ua.includes('Edg/')) {
    return 'Microsoft Edge';
  } else if (ua.includes('FBIOS')) {
    return 'Facebook Mobile';
  } else if (ua.includes('Chrome')) {
    return 'Chrome';
  } else if (ua.includes('CriOS')) {
    return 'Chrome iOS';
  } else if (ua.includes('UCWEB') || ua.includes('UCBrowser')) {
    return 'UC Browser';
  } else if (ua.includes('FxiOS')) {
    return 'Firefox iOS';
  } else if (vendor.includes('Apple')) {
    if (ua.includes('Mobile')) {
      return 'Mobile Safari';
    }
    return 'Safari';
  } else if (ua.includes('Android')) {
    return 'Android Mobile';
  } else if (ua.includes('Konqueror')) {
    return 'Konqueror';
  } else if (ua.includes('Firefox')) {
    return 'Firefox';
  } else if (ua.includes('MSIE') || ua.includes('Trident/')) {
    return 'Internet Explorer';
  } else if (ua.includes('Gecko')) {
    return 'Mozilla';
  }
  return '';
};

/* istanbul ignore next */
export const getOS = () => {
  const ua = navigator.userAgent;

  if (ua.includes('Windows')) {
    if (ua.includes('Phone') || ua.includes('WPDesktop')) {
      return 'Windows Phone';
    }
    return 'Windows';
  } else if (/(iPhone|iPad|iPod)/.test(ua)) {
    return 'iOS';
  } else if (ua.includes('Android')) {
    return 'Android';
  } else if (/(BlackBerry|PlayBook|BB10)/i.test(ua)) {
    return 'BlackBerry';
  } else if (/Mac/i.test(ua)) {
    return 'Mac OS X';
  } else if (ua.includes('Linux')) {
    return 'Linux';
  } else if (ua.includes('CrOS')) {
    return 'Chrome OS';
  }
  return '';
};

/* istanbul ignore next */
export const getBrowserVersion = () => {
  const browser = getBrowser();

  if (!browser) {
    return null;
  }

  const ua = navigator.userAgent;

  const versionRegexs: Record<string, RegExp> = {
    'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
    'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
    Chrome: /Chrome\/(\d+(\.\d+)?)/,
    'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
    'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
    Safari: /Version\/(\d+(\.\d+)?)/,
    'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
    Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
    Firefox: /Firefox\/(\d+(\.\d+)?)/,
    'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
    Konqueror: /Konqueror:(\d+(\.\d+)?)/,
    BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
    'Android Mobile': /android\s(\d+(\.\d+)?)/,
    'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
    'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
    Mozilla: /rv:(\d+(\.\d+)?)/,
  };

  const regex = versionRegexs[browser];
  if (!regex) {
    return null;
  }

  const matches = ua.match(regex);
  if (!matches) {
    return null;
  }

  return parseFloat(matches[matches.length - 2] || '0');
};

/* istanbul ignore next */
export const getNewUUID = () => {
  // Time/ticks information
  // 1*new Date() is a cross browser version of Date.now()
  const T = function () {
    const d = new Date().getTime();
    let i = 0;

    // this while loop figures how many browser ticks go by
    // before 1*new Date() returns a new number, ie the amount
    // of ticks that go by per millisecond
    while (d === new Date().getTime()) {
      i++;
    }

    return d.toString(16) + i.toString(16);
  };

  // Math.Random entropy
  const R = function () {
    return Math.random().toString(16).replace('.', '');
  };

  // User agent entropy
  // This function takes the user agent string, and then xors
  // together each sequence of 8 bytes.  This produces a final
  // sequence of 8 bytes which it returns as hex.
  const UA = function () {
    const ua = navigator.userAgent;
    let i;
    let ch;
    let buffer: any[] = [];
    let ret = 0;

    function xor(result: number, byteArray: any[]) {
      let j;
      let tmp = 0;
      for (j = 0; j < byteArray.length; j++) {
        tmp |= buffer[j] << (j * 8);
      }
      return result ^ tmp;
    }

    for (i = 0; i < ua.length; i++) {
      ch = ua.charCodeAt(i);
      buffer.unshift(ch & 0xff);
      if (buffer.length >= 4) {
        ret = xor(ret, buffer);
        buffer = [];
      }
    }

    if (buffer.length > 0) {
      ret = xor(ret, buffer);
    }

    return ret.toString(16);
  };

  const se = (window.outerHeight * window.outerWidth).toString(16);
  // eslint-disable-next-line new-cap
  return `${T()}-${R()}-${UA()}-${se}-${T()}`;
};

/* istanbul ignore next */
export const getReferringDomain = () => {
  const split = (document.referrer || '').split('/');
  if (split.length >= 3) {
    return split[2];
  }
  return '';
};
